<section class="the-essentials">
  <!-- Pestañas: solo las que tienen productos -->
  <div class="the-essentials__tabs d-flex scroll-hidden" role="tablist">
    <ng-container *ngIf="loading; else tabList">
      <div *ngFor="let _ of skeletonTabs" class="the-essentials__tab is-loading d-flex ai-center">
        <ngx-skeleton-loader [theme]="{ width: '8rem', height: '1.5rem', 'border-radius': '0.5rem', 'margin-bottom': '0' }"></ngx-skeleton-loader>
      </div>
    </ng-container>
    <ng-template #tabList>
      <button
        *ngFor="let tab of visibleTabs"
        type="button"
        role="tab"
        class="the-essentials__tab d-flex ai-center cursor-pointer"
        [class.is-active]="tab.id === activeTab"
        [attr.aria-selected]="tab.id === activeTab"
        (click)="selectTab(tab.id)"
      >
        <span class="the-essentials__tab-icon" [ngClass]="'is-' + tab.icon" aria-hidden="true"></span>
        {{ tab.label }}
      </button>
    </ng-template>
  </div>

  <!-- Franja de la pestaña -->
  <div *ngIf="loading; else banner" class="the-essentials__banner is-loading d-flex ai-center jc-center">
    <ngx-skeleton-loader class="the-essentials__banner-skeleton" [theme]="{ width: '100%', height: '1.5625rem', 'border-radius': '0.5rem', 'margin-bottom': '0' }"></ngx-skeleton-loader>
  </div>
  <ng-template #banner>
    <div *ngIf="activeTab === 'imperdonables'" class="the-essentials__banner is-unmissables d-flex ai-center jc-center">
      <span class="the-essentials__banner-icon is-unmissables" aria-hidden="true"></span>
      <p class="the-essentials__banner-text m-0">
        <span class="the-essentials__banner-title">IMPERDONABLES,</span> productos que siempre compras. ¡Listos para pedirlos de nuevo!
      </p>
    </div>
    <div *ngIf="activeTab === 'infaltables'" class="the-essentials__banner is-essentials d-flex ai-center jc-center">
      <span class="the-essentials__banner-icon is-essentials" aria-hidden="true"></span>
      <p class="the-essentials__banner-text m-0">
        <span class="the-essentials__banner-title">INFALTABLES,</span> productos que tu competencia está vendiendo.
      </p>
    </div>
  </ng-template>

  <!-- Listado -->
  <div *ngIf="loading; else productList" class="the-essentials__grid">
    <app-essentials-card-skeleton *ngFor="let _ of skeletonCards"></app-essentials-card-skeleton>
  </div>
  <ng-template #productList>
    <div class="the-essentials__grid">
      <app-essentials-card
        *ngFor="let card of products[activeTab]; trackBy: trackBySku"
        [cardData]="card"
        [listData]="listData[activeTab].name"
        [listIdData]="listData[activeTab].id"
      ></app-essentials-card>
    </div>
  </ng-template>

  <!-- Vuelve al inicio de la página -->
  <button type="button" class="the-essentials__scroll-top d-flex flex-column ai-center jc-center cursor-pointer"
    [class.is-visible]="showScrollTop" [attr.aria-hidden]="!showScrollTop" [attr.tabindex]="showScrollTop ? null : -1" (click)="scrollToTop()">
    <span class="the-essentials__scroll-top-icon" aria-hidden="true"></span>
    Subir
  </button>
</section>
